import React, { useState } from "react";
import ShareTable from "../../../shares/tables/ShareTable";
import {
  FileDownloadOutlined,
  RuleFolderOutlined,
} from "@mui/icons-material";
import AddAnswer from "./modals/AddAnswer";
import useFetch from "../../../../hooks/useFetch";
import moment from "jalali-moment";
import { useSearchParams } from "react-router-dom";
import { Modal } from "@mui/material";
import Search from "../../../shares/search/Search";
import {
  PageHeader,
  StatusBadge,
} from "../../../shares/dashboard/DashboardWidgets";

const HomeworkAnswers = () => {
  const [filterChoice, setFilterChoice] = useState("همه");
  const [classFilter, setClassFilter] = useState("");
  const [newModal, setNewModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [assignmentScores, setAssignmentScores] = useState();
  const [newAssignment, setNewAssignment] = useState();
  const [id, setId] = useState();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleClose = () => {
    setNewModal(false);
    setEditModal(false);
    setDeleteModal(false);
  };

  const getAssignment = useFetch({
    method: "GET",
    url: "management/assignment-scores/",
    params: { page: searchParams.get("page") || 1, search: searchParams.get("search") || "" },
    safeRead: true,
    noHeader: false,
    trigger: true,
    setter: setAssignmentScores,
  });

  const handleCorrect = (id) => {
    setNewModal(true);
    setId(id);
  };

  const columns = [
    { id: "id", label: "Id" },
    {
      id: "name",
      label: "نام",
      render: (row) =>
        row.assignment_average_reffer.user.first_name +
        " " +
        row.assignment_average_reffer.user.last_name,
    },
    {
      id: "assignment_name",
      label: "نام تکلیف",
      render: (row) => row.assignment.AssignmentName,
    },
    { id: "score", label: "نمره" },
    {
      id: "updated_file_at",
      label: "زمان آپلود",
      render: (row) =>
        moment(row.updated_file_at, "YYYY/MM/DD HH:mm")
          .locale("fa")
          .format("YYYY/MM/DD HH:mm"),
    },
    {
      id: "assignment_answer",
      label: "جواب",
      render: (row) =>
        row.assignment_student_file ? (
          <a
            href={`${row.assignment_student_file}`}
            download
            aria-label="دانلود جواب دانش‌آموز"
            className="inline-flex h-[3.2rem] w-[3.2rem] items-center justify-center rounded-soft text-ink-muted transition-colors duration-150 hover:bg-primary-soft hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          >
            <FileDownloadOutlined sx={{ fontSize: "1.9rem" }} />
          </a>
        ) : (
          <span className="text-ink-subtle">—</span>
        ),
    },
    {
      id: "assignment_corrected",
      label: "تصحیح شده",
      render: (row) =>
        row.assignment_marked && row.assignment_teacher_file ? (
          <a
            href={`${row.assignment_teacher_file}`}
            download
            aria-label="دانلود فایل تصحیح‌شده"
            className="inline-flex h-[3.2rem] w-[3.2rem] items-center justify-center rounded-soft text-ink-muted transition-colors duration-150 hover:bg-primary-soft hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          >
            <FileDownloadOutlined sx={{ fontSize: "1.9rem" }} />
          </a>
        ) : (
          <span className="text-ink-subtle">—</span>
        ),
    },
    {
      id: "assignment_marked",
      label: "وضعیت",
      render: (row) => (
        <StatusBadge
          label={row.assignment_marked ? "تصحیح شده" : "تصحیح نشده"}
          tone={row.assignment_marked ? "success" : "warning"}
        />
      ),
    },
    { id: "assignment_marked_by", label: "مصحح" },
    {
      id: "assignment_correct",
      label: "",
      render: (row) => (
        <button
          type="button"
          onClick={() => handleCorrect(row.id)}
          className="rounded-soft bg-primary px-lg py-xs text-sm text-white transition-colors duration-150 hover:bg-primary-hover active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary motion-reduce:transition-none"
        >
          تصحیح
        </button>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-xl pb-4xl">
      <PageHeader
        title="تصحیح تکلیف‌ها"
        description="پاسخ‌های ارسالی دانش‌آموزان و ثبت نمره"
        icon={RuleFolderOutlined}
      />

      <div className="flex flex-col gap-lg">
        <Search getFiltered={getAssignment} />

        <ShareTable
          data={assignmentScores?.results ?? []}
          columns={columns}
          getPage={getAssignment}
          totalCount={assignmentScores?.count}
          page={Number(searchParams.get("page")) || 1}
          setPage={setSearchParams}
        />
      </div>

      <Modal
        open={newModal}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <AddAnswer close={handleClose} get={getAssignment} id={id} />
      </Modal>
    </div>
  );
};

export default HomeworkAnswers;
